module.exports = __webpack_public_path__ + "img/tigers.c3e5e425.svg";